/* Below are the types of search considered complex for new Search V2 UI. Saved Search that contains one
   of these types will be redirected to Analyzer page form to edit filters. */
export const checkSearchQueryHasUnsupportedEntity = (searchQuery = []) => {
  const hasBooleanTextSearches =
    searchQuery.filter((q) => q.entity === 'bool_text_search')?.length > 1;
  const hasOrOperator = !!searchQuery.find((q) => q.operator === 'or');
  const hasSection = !!searchQuery.find((q) => q.entity === 'section');

  return hasBooleanTextSearches || hasOrOperator || hasSection;
};

export const testIsSearchV3ComplexQuery = (searchQuery = []) => {
  const hasSection = !!searchQuery.find((q) => q.entity === 'section');
  const hasOrOperator = !!searchQuery.find((q) => q.operator === 'or');

  return hasSection || hasOrOperator;
};
